import { render, staticRenderFns } from "./RadialCategories.vue?vue&type=template&id=7c36e53a&scoped=true&"
import script from "./RadialCategories.vue?vue&type=script&lang=js&"
export * from "./RadialCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c36e53a",
  null
  
)

export default component.exports